import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAreaGet = async (credentials, data) => {
  const body = {
    service: "RNHAreaGet",
    params: {
      rnhAreaCod: data?.areaCod || null,
      rnhZonaCod: data?.zonaCod || null,
      soloDisponibles: data?.areaDisponible || null,
      rnhEstablecimientoId: data?.hospitalId || null,
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
